import NotificationDrawer from "../../components/drawers/NotificationDrawer";

export const DRAWER_KEY = {
  Notification: 'notification'
} as const;

export type DrawerKey = typeof DRAWER_KEY[keyof typeof DRAWER_KEY];

export const DRAWER_COMPONENTS_MAP = {
  [DRAWER_KEY.Notification]: NotificationDrawer,
} as const;